import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { TranslocoModule, TranslocoService } from '@ngneat/transloco';
import { Store } from '@ngrx/store';
import { map } from 'rxjs/operators';
import { selectLoading as selectCartLoading } from '@us/web/cart/data-access';
import { OrdersActions, OrdersApiService, selectLoading as selectOrdersLoading } from '@us/web/orders/data-access';
import { Order, OrderState, OrderStatus, PaymentType } from '@us/web/shared/data-access';
import { MessageService } from '@us/web/shared/feature';
import { combineLatest } from 'rxjs';
import { TuiButtonModule, TuiSvgModule } from '@taiga-ui/core';
import { AsyncPipe, NgForOf, NgIf, NgSwitch, NgSwitchCase, NgTemplateOutlet } from '@angular/common';
import { FormatPipeModule, ParseIsoPipeModule } from 'ngx-date-fns';
import { TuiAvatarModule } from '@taiga-ui/kit';
import { OrderStateComponent } from '@us/web/orders/ui';
import { EmptyComponent } from '@us/web/shared/ui';
import { getOrderPaymentUrl } from '@us/web/shared/utils';

@Component({
    selector: 'us-order-status',
    templateUrl: './order-status.component.html',
    styleUrls: ['./order-status.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        TuiButtonModule,
        NgIf,
        NgForOf,
        NgSwitch,
        NgSwitchCase,
        NgTemplateOutlet,
        TranslocoModule,
        AsyncPipe,
        TuiSvgModule,
        ParseIsoPipeModule,
        FormatPipeModule,
        TuiAvatarModule,
        OrderStateComponent,
        EmptyComponent
    ],
    standalone: true
})
export class OrderStatusComponent implements OnChanges {
    @Input() order!: Order;
    @Input() hideReloadButton = false;

    readonly OrderState = OrderState;
    readonly PaymentType = PaymentType;
    btnLoad = false;
    linkPayment: string | null = null;
    states: OrderStatus[] = [];

    isLoading$ = combineLatest([this.store.select(selectCartLoading), this.store.select(selectOrdersLoading)]).pipe(
        map(([cartLoading, ordersLoading]) => cartLoading || ordersLoading)
    );

    constructor(
        private ordersService: OrdersApiService,
        private cdr: ChangeDetectorRef,
        private messageService: MessageService,
        private translocoService: TranslocoService,
        private store: Store
    ) {}

    ngOnChanges(changes: SimpleChanges) {
        const order = changes['order'].currentValue;
        this.linkPayment = getOrderPaymentUrl(order);
        this.cdr.markForCheck();
        this.states = [...(this.order.states ?? [])].reverse();
    }

    checkTransactionStatus() {
        this.store.dispatch(OrdersActions.loadOrderPaymentStatus({ id: this.order.order_id }));
    }

    onRefresh() {
        this.store.dispatch(OrdersActions.loadOrder({ id: this.order.order_id }));
    }
}
